<template>
  <div>
    <component
      :is="showSideBarImprovements ? 'AppSidebarRedesign' : 'AppSidebar'"
    >
      <div :class="{ 'u-bg-neutral-background': showSideBarImprovements }">
        <nav v-if="type === 'personal'" class="sidebar__nav-list">
          <ul>
            <li class="li-group">
              <div class="li-root">{{ $t('common.linkSettings') }}</div>

              <ul>
                <li v-for="(link, key) in accountLinks" :key="`account-${key}`">
                  <router-link
                    :to="link.to"
                    :data-cy="`account-${link.id}`"
                    @click.native="toggleMobileMenu"
                  >
                    {{ $t(link.titleKey) }}
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="li-group">
              <div class="li-root">{{ $t('navigation.support') }}</div>

              <ul>
                <li>
                  <router-link :to="{ name: 'FaqHome' }" target="_blank">
                    {{ $t('navigation.faqs') }}
                  </router-link>
                </li>

                <li>
                  <router-link
                    to="/settings/contact"
                    @click.native="toggleMobileMenu"
                  >
                    {{ $t('navigation.contactUs') }}
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </component>

    <MainLayout>
      <BaseSpinner
        v-if="unitDetails.loading"
        data-cy="settings-spinner"
        class="u-margin-top-12x"
      />
      <router-view v-else-if="!useslot"></router-view>
      <slot v-else></slot>
    </MainLayout>
  </div>
</template>

<script>
import { BaseSpinner } from '@samknows/design-system';
import MainLayout from '@/common/components/MainLayout.vue';
import AppSidebar from '@/common/components/SideBar.vue';
import viewTypes from '@/common/helpers/view-types';
import AppSidebarRedesign from '@/common/components/SideBarRedesign.vue';

export default {
  components: {
    MainLayout,
    AppSidebar,
    AppSidebarRedesign,
    BaseSpinner
  },
  props: {
    useslot: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    type: 'personal',
    unitId: viewTypes.activeView.data.unitId
  }),

  computed: {
    showSideBarImprovements() {
      return this.$store.state.menus.isSideBarImprovementsEnabled;
    },
    unitDetails() {
      return this.$store.state.personalDetails.unitDetails;
    },

    isHomeUser() {
      return viewTypes.isConsumerView && viewTypes.activeView.data.unitId;
    },

    accountLinks() {
      const links = [
        {
          to: '/settings/personal-details',
          titleKey: 'navigation.personalDetails',
          id: 'personal-details',
          show: true
        },
        {
          to: { name: 'BroadbandDetails' },
          titleKey: 'navigation.myBroadband',
          id: 'broadband-details',
          show: this.isHomeUser
        },
        {
          to: '/settings/email-preferences',
          titleKey: 'navigation.emailPrefs',
          id: 'email-preferences',
          show: true
        }
      ];

      return links.filter((link) => link.show);
    }
  },

  async created() {
    if (viewTypes.isConsumerView && this.unitId) {
      await this.$store.dispatch('personalDetails/fetchUnitDetails');
    }
  },

  methods: {
    toggleMobileMenu() {
      this.$store.commit('menus/toggleMenu', false);
    }
  }
};
</script>
